import React from "react";
import Button from "../../../components/Button";
import "./ModeButton.css";

export function ModeButton({ active, ...props }) {
  return (
    <Button
      className={`mode-button ${active ? "Button--black" : "Button--card"}`}
      size="S"
      theme="bordered"
      data-active={active}
      iconPosition="before"
      {...props}
    />
  );
}
